import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';
const Toaster = ({ ...props }) => {
    const { theme = 'system' } = useTheme();
    return _jsx(Sonner, { theme: theme, className: "toaster group", ...props });
};
export { Toaster };
//# sourceMappingURL=sonner.js.map